module.exports = __webpack_public_path__ + "media/icons/cs-c23d0ce4e9bcc7f8a443d29d3e7f0256.svg";